import Button, { ButtonProps } from '@/components/ui/button'
import { Image } from '@/components/ui/image'
import { Text } from '@/components/ui/text'
import { Box, Flex } from '@/styled-system/jsx'
import { useTranslations } from 'next-intl'
import { forwardRef, useState } from 'react'

export type HeaderRewardsTriggerProps = ButtonProps & {
  availableRewardsCount?: number
}

const HeaderRewardsTrigger = forwardRef<
  HTMLButtonElement,
  HeaderRewardsTriggerProps
>(function HeaderRewardsTrigger(props, ref) {
  const { availableRewardsCount, ...other } = props
  const [isHovered, setIsHovered] = useState(false)
  const t = useTranslations()
  return (
    <Button
      ref={ref}
      variant='neutral'
      size='md'
      //bgColor='#221825'
      //boxShadow='inset 0 0 0 1px rgba(194, 194, 194, 0.05)'
      borderRadius='lg'
      textStyle='sm'
      px='16px'
      h='11'
      {...other}
      //color='#A08DAD'
    >
      <Text>{t('rewards-title')}</Text>
    </Button>
  )
  /*return (
    <Button
      ref={ref}
      variant='unstyled'
      size='md'
      bgColor='#1d0e20'
      bgImage='radial-gradient(48.28% 48.28% at 49.66% 100%, rgba(233, 0, 131, 0.20) 0%, rgba(29, 14, 32, 0.20) 100%), #1D0E20;'
      boxShadow='inset 0 0 0 1px rgba(194, 194, 194, 0.05)'
      borderRadius='lg'
      textStyle='sm'
      px='26px'
      h='11'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      _hover={{
        bgColor: '#241127',
        '& > .inner-crown img': {
          mt: '-5px',
        },
        '& > .pink-crow': {
          mt: '-5px',
        },
      }}
      {...other}
    >
      <Flex
        className='inner-crown'
        position='absolute'
        inset='0'
        overflow='hidden'
        h='full'
        w='full'
        zIndex='0'
      >
        <Image
          src='/assets/reward-pink-trophy-lg.svg'
          alt='Pink Crown'
          position='absolute'
          top='4px'
          left='50%'
          transform='translateX(-50%)'
          opacity='0.15'
          filter='drop-shadow(0px 0px 11px rgba(233, 0, 131, 0.5))'
          transitionProperty='margin-top'
          transitionDuration='normal'
          transitionTimingFunction='linear'
          h='51px'
          w='66px'
          zIndex='-1'
        />
      </Flex>
      <Image
        className='pink-crow'
        src='/assets/reward-pink-trophy.svg'
        alt='Pink Crown'
        position='absolute'
        left='-8px'
        top='50%'
        transform='translateY(-50%)'
        filter='drop-shadow(0px 4px 5px rgba(25, 13, 28, 0.70))'
        transitionProperty='margin-top'
        transitionDuration='normal'
        transitionTimingFunction='linear'
        h='22px'
        w='28px'
        zIndex='30'
      />

      <Box
        bg='linear-gradient(to right,transparent 0%,rgba(255, 156, 228, 0.5) 25%, #E90083 50%,rgba(255, 156, 228, 0.5) 75%, transparent 100%)'
        position='absolute'
        left='0'
        right='0'
        bottom='0px'
        mx='auto'
        h='1px'
        w='90%'
        transitionProperty='opacity'
        transitionDuration='normal'
        transitionTimingFunction='linear'
        opacity={isHovered ? 1 : 0}
        borderRadius='lg'
      />
      <Text
        as='span'
        fontWeight='normal'
        position='relative'
        textShadow='0px 2px 20px white'
        zIndex={20}
      >
        OINK
        <Text as='b' fontWeight='bold'>
          CLUB
        </Text>
      </Text>

      {availableRewardsCount && availableRewardsCount > 0 ? (
        <Flex
          align='center'
          justify='center'
          position='absolute'
          top='-9px'
          right='-11px'
          borderRadius='sm'
          w='22px'
          h='18px'
          bgColor='primary'
          boxShadow='0 0 6px rgba(233, 0, 131, 0.8)'
          color='white'
          fontSize='10px'
          fontWeight='bold'
          animationName='scale-in'
          animationDuration='0.1s'
        >
          {availableRewardsCount}
        </Flex>
      ) : null}
    </Button>
  )*/
})

export default HeaderRewardsTrigger
